const SRAM_TABLE = {
  joust: ['000000', 0],
  joustr: ['000001', 0],
  jousty: ['000002', 0],
  defender: ['000003', 0],
  defenderg: ['000004', 0],
  defenderb: ['000005', 0],
  defenderw: ['000006', 0],
  defenderj: ['000007', 0],
  defcmnd: ['000008', 0],
  startrkd: ['000009', 0],
  defence: ['000010', 0],
  galwars2: ['000011', 0],
  stargate: ['000012', 0],
  robotron: ['000013', 0],
  robotronyo: ['000014', 0],
  robotronun: ['000015', 0],
  robotron87: ['000016', 0],
  robotron12: ['000017', 0],
  robotrontd: ['000018', 0],
  bubbles: ['000019', 0],
  bubblesr: ['000020', 0],
  bubblesp: ['000021', 0],
  splat: ['000022', 0],
  spdball: ['000023', 0],
  sinistar: ['000024', 0],
  sinistar2: ['000025', 0],
  sinistarp: ['000026', 0],
  blaster: ['000027', 0],
  loffire: ['000028', 0],
  arkretrn: ['000029', 1],
  arkretrnu: ['000030', 1],
  arkretrnj: ['000031', 1],
  puchicar: ['000032', 1],
  puchicaru: ['000033', 1],
  puchicarj: ['000034', 1],
  slither: ['000035', 0],
  slithera: ['000036', 0],
  loffired: ['000037', 0],
  loffirej: ['000038', 0],
  loffirejd: ['000039', 0],
  loffireu: ['000040', 0],
  loffireud: ['000041', 0],
  lghost: ['000042', 0],
  lghostd: ['000043', 0],
  lghostj: ['000044', 0],
  lghostu: ['000045', 0],
  lghostud: ['000046', 0],
  qix: ['000047', 0],
  qixa: ['000048', 0],
  qixb: ['000049', 0],
  qixo: ['000050', 0],
  qix2: ['000051', 0],
  zookeep: ['000052', 0],
  zookeep2: ['000053', 0],
  zookeep3: ['000054', 0],
  sdungeon: ['000055', 0],
  sdungeona: ['000056', 0],
  elecyoyo: ['000057', 0],
  elecyoyo2: ['000058', 0],
  kram: ['000059', 0],
  kram2: ['000060', 0],
  complexx: ['000061', 0],
};

export default SRAM_TABLE;
